
import React, { useState } from 'react';
import './App.css';
import 'semantic-ui-css/semantic.min.css'
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import 'firebase/analytics';
import { useAuthState } from 'react-firebase-hooks/auth';

import ChatRoom from './components/ChatRoom';

import { config } from './config';
import { Router } from "@reach/router";
import Login from './auth/LoginUser';
import SignUp from './auth/SignUp';
import { AuthProvider } from "./contexts/AuthContext"

import { useCollectionData } from 'react-firebase-hooks/firestore';


firebase.initializeApp(config);

export const auth = firebase.auth();

export const firestore = firebase.firestore();
//const analytics = 
firebase.analytics();
//analytics.logEvent('notification_received');

function App() {
  const scoresRef = firestore.collection('scores');
  const queryScores = scoresRef.orderBy('lasthighscore', "desc").limit(5); // limit 25 but below I reverse the list
  const [scores] = useCollectionData(queryScores, { idField: 'id' });
  const [user] = useAuthState(auth);
  const [score, stateScore] = useState(0)

  const UpdateScore = (scoreAddedValue) => {

    const currentScore = score + scoreAddedValue;
    stateScore(currentScore);
    updateLeaderBoard(currentScore);
  }

  const updateLeaderBoard = async (currentScore) => {

    const { uid } = auth.currentUser;
    const { displayName } = auth.currentUser;

    var docRef = scoresRef.doc(uid);
    var lasthighscore;
    
    docRef.get().then((doc) => {
      if (doc.exists) {
        lasthighscore = doc.data().lasthighscore;

        if (currentScore > lasthighscore) {
          lasthighscore = currentScore;

        }
        scoresRef.doc(uid).set({
          score: currentScore,
          lasthighscore: lasthighscore,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          uid,
          nick: displayName

        });
      } else {

        console.log("No such document!");
        lasthighscore = 0
        scoresRef.doc(uid).set({
          score: currentScore,
          lasthighscore: lasthighscore,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          uid,
          nick: displayName

        });

      }
    }).catch((error) => {
      console.log("Error getting document:", error);
    });
  }

  // https://github.com/WebDevSimplified/React-Firebase-Auth/blob/master/src/components/App.js

  return (
    <div className="App">

      <div className="container">
        {user ? <ChatRoom UpdateScore={UpdateScore} auth={auth} scores={scores} score={score} /> :
          <AuthProvider>
            <Router>

              <Login path="/" />
              <SignUp path="/signUp" />

            </Router>
          </AuthProvider>
        }

      </div>
    </div>
  );
}

export default App;


